/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownTaskTyped } from '../models/db_DropdownTaskTyped';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Tasks {
    /**
     * Get a list of tasks
     * @returns db_DropdownTaskTyped OK
     * @throws ApiError
     */
    public static listTasks(): CancelablePromise<Array<db_DropdownTaskTyped>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tasks',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
